import { render, staticRenderFns } from "./addRreportConfig.vue?vue&type=template&id=0b0276a6&"
import script from "./addRreportConfig.vue?vue&type=script&lang=js&"
export * from "./addRreportConfig.vue?vue&type=script&lang=js&"
import style0 from "./addRreportConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b0276a6')) {
      api.createRecord('0b0276a6', component.options)
    } else {
      api.reload('0b0276a6', component.options)
    }
    module.hot.accept("./addRreportConfig.vue?vue&type=template&id=0b0276a6&", function () {
      api.rerender('0b0276a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/components/addRreportConfig.vue"
export default component.exports